(function () {

  'use strict';

  eclipseApp.directive('uteProvinceSelector', function () {

    return {
      scope: true,
      replace: true,
      templateUrl: 'modules/components/views/province-selector.html',
      restrict: 'E',
      controller: 'provinceSelectorCtrl'
    };

  });

})();
